import React from 'react';
import { twMerge } from 'tailwind-merge';

const TextBox = ({ color, padded, resp, vertical, title, descr, children, className }) => {
  return (
    <div className={twMerge('flex w-full overflow-y-clip group', resp && "resp", padded && "py-8", className)}>
      <div className={twMerge(vertical && "md:landscape:flex-col gap-6 text-left", 'flex max-md:flex-col w-full mx-auto mt-12 gap-8')}>
        <div className='flex flex-col w-full max-w-[40ch] -mt-2'>
          <h3 className='max-sm:mb-4 !font-medium'>{title}</h3>
          {/* ADD SUB IF NEEDED */}
        </div>

        <div className='flex flex-col maxW2 gap-10 '>
          <h4 className='font-light mx-auto= text-left whitespace-pre-line dim group-hover:nodim leading-relaxed quick font-poppins'>
            {descr}
          </h4>
        </div>
      </div>
    </div>
  )
}

export default TextBox